module.exports = {
	"5fe6cc0473e0d313": "Login failure",
	"ff09e2c6d332d9a9": "After-sales service manager of maintenance distributor",
	"e700c28686cf9239": "Service manager",
	"ac4b9e617b460217": "Original owner",
	"cf9e55be6bc85b96": "Overview",
	"2b68d9152e3d3db1": "Head of national defense department",
	"051d6d3c0467ce2c": "Sales company",
	"8d7d36bc6fb6d6ac": "Administration department",
	"2c3949540a8af2b2": "Network order delivery department at east district",
	"5cabbc13e4bee21a": "Administrator",
	"42c4c030fab33ead": "Marketing department",
	"54f11cc55ea6122f": "Brand distributor A",
	"d115f29ef6edb41f": "Sales department",
	"3417a5fcc3a35dec": "Sales branch",
	"7bd27a06c47deebb": "Sales branch of distributor A",
	"465d732d68ebdfbb": "Succeeded",
	"d3ad9f48039d6f36": "Enter a password that complies with the rules",
	"9b9a980dcdf8e51a": "The password must be a string of 10 to 16 characters: including at least three types of the following: uppercase letters, lowercase letters, digits, and special characters (only `~!@#$%^&*()_-)",
	"db2a83c04d0d85ee": "One",
	"c9e78713e31e5c0c": "Two",
	"a0da04db4f9323b6": "Three",
	"11071e8d339b611c": "Four",
	"77c043016d325c68": "Five ",
	"3d86ac98afd3c98b": "Six ",
	"ac2c5e612fb71dbb": "Day",
	"2a314654cf9d4b65": "Just now",
	"400201ee4590ba25": "Minute(s) ago",
	"38dff0847f8b6b54": "Hour(s) ago",
	"acc203985e88c8ff": "1 days ago",
	"9954ce6437e66f41": "Month",
	"08dae0e0a7266acb": "Hour",
	"cdf97643b4d2b4ec": "Minute",
	"9e8d6372f23ed0ae": "Copyrighted ",
	"922c2d41bd36ae30": "Please check whether the URL you entered is correct. Please click the button below to return to the home page or send an error report",
	"8cd396b24d50bde9": "Homepage",
	"34655267df949d36": "The page you visited does not exist...",
	"0c09f9f949502219": "Enter your membership name/mobile phone number/email address",
	"": "Please enter your password",
	"f787a49b96414843": "Please select a login category",
	"29feb2a0dd8c64aa": "Distributor",
	"136c1cfccaefce89": "OEM",
	"a16c753c0ce27b93": "Consumer ",
	"a787eaff540ed815": "Chery International Intelligent Marketing Platform",
	"8efc7ede2b82d0d2": "Welcome to login",
	"b6bd35b4275ff215": "Common login",
	"c7609e554782bec4": "Login",
	"5c839808c79ec750": "Forget the password?",
	"4c04782973d13249": "lease enter the correct password",
	"35a9eeeeed94b9c5": "Authentication ",
	"1f899a083534373c": "Reset password",
	"25e03120b83ee4ed": "Completed",
	"3037d5200851358c": "Enter new password",
	"12486c6be40db3e7": "Enter new password again",
	"204ffab8a6e01870": "OK",
	"cb5652273096ee32": "Return to login page",
	"47a48843580a4a66": "Please enter the password in correct format",
	"9be71a11b46a4836": "The two passwords entered differ",
	"6f43ea859d9f785b": "The password contains 10 to 16 characters, including at least digits, letters, and characters (only `~!@#$%^&*()_-))",
	"5f572f4cad00da16": "Succeeded in resetting the password",
	"29799f539ee6b906": "Please enter your mobile phone number",
	"f1ee1d97e869e447": "Please enter the verification code",
	"03108ca21c7aae62": "You can obtain it again in {0} seconds",
	"ace46c7b30cb9a6e": "Get verification code",
	"b0dd7bfe25cfcd7c": "Please enter the correct mobile phone number",
	"c54f71547450a65d": "The verification code has been successfully sent to {0}",
	"582eb6b01e3ddd0e": "Cell phone number login",
	"b43c9693cd8c2a86": "Account Login",
	"e4e4d24449be2f3b": "Email Login",
	"a4132369592eddf8": "Please enter your phone number",
	"7b04a69f42606895": "Please enter your account number",
	"616d3762556837aa": "Please enter your email address",
	"f6f6a306a8b4e68c": "Enter your phone number",
	"e78e5ae48541083f": "Enter your account number",
	"e1171e54815f0502": "Enter your email address",
	"2d394cf2150beea9": "Account login",
	"9cd180bf2c9735b7": "Failed to send the verification code. Please check your phone number.",
	"e93cb6cc8d5978ed": "Please enter password",
	"d49a93bb265a311d": "Verification code",
	"e3fed7761201cc22": "Can't see clearly, please change to another one",
	"ad4345dbaabe1479": "Submit"
};



//////////////////
// WEBPACK FOOTER
// ./locale/en.js
// module id = RH0W
// module chunks = 8